var pt = pt || {};
pt.blocografico = pt.blocografico || {};
pt.blocografico.modules = pt.blocografico.modules || {};
pt.blocografico.modules.generic_content = pt.blocografico.modules.generic_content || {};
pt.blocografico.modules.generic_content = (function () {
  function initInteractions() {
    document.querySelectorAll(".interaction").forEach(function (iframe) {
      iframe.addEventListener("load", function () {
        try {
          var body = iframe.contentWindow.document.body;
          var observer = new ResizeObserver(function () {
            var height = body.scrollHeight;
            if (height > 0) iframe.style.height = height + "px";
          });
          observer.observe(body);
        } catch (e) {
          // cross-origin in dev — fixed height fallback remains
        }
      });
    });
  }

  function init() {
    pt.blocografico.library.modalMedia.init(savePlaybackState);
    initInteractions();
  }

  return { init };
})();

document.addEventListener("DOMContentLoaded", function () {
  pt.blocografico.modules.generic_content.init();
});
